export * from './job-summary.component';
export * from './job-summary.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-summary/index.ts